import OperatorAddRequest, {
  OperatorAddRequestBody,
} from "./operator-add-request";

const createBody = (data: OperatorAddRequest): OperatorAddRequestBody => {
  return {
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    mobilePrimary: data.mobilePrimary,
    mobilePrimaryPrefix: data.mobilePrimaryPrefix,
    mobileSecondary: data.mobileSecondary,
    mobileSecondaryPrefix: data.mobileSecondaryPrefix,
    password: data.password,
    username: data.username,
  };
};

const operatorAddRequestFactory = {
  createBody,
};

export default operatorAddRequestFactory;
